import React from 'react';


const BetweenValue = () => {
  return (
    <>
      {/*TODO*/}
    </>
  );
}

export default BetweenValue;